import React from 'react'
import {
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  IconButton,
} from '@chakra-ui/react'
import { TableBodyMassProjectList } from '../molecules/projects/TableBodyMassProjectList'
import { AiOutlineSortAscending, AiOutlineSortDescending } from 'react-icons/ai'
import { BsSortNumericDown, BsSortNumericUp } from 'react-icons/bs'

export const TableMassProjectList2 = (props) => {
  const {
    projects,
    isReverse,
    onClickOpenProjectDetail,
    onClickSort,
    onClickSortReverse,
  } = props

  return (
    <TableContainer mb={2}>
      <Table variant="striped" colorScheme="linkedin">
        <Thead>
          <Tr>
            <Th>
              顧客名
              {isReverse['client_name'] ? (
                <IconButton
                  aria-label="search"
                  onClick={onClickSortReverse}
                  icon={<AiOutlineSortDescending />}
                />
              ) : (
                <IconButton
                  aria-label="search"
                  onClick={() => onClickSort('client_name')}
                  icon={<AiOutlineSortAscending />}
                />
              )}
            </Th>
            <Th>担当者</Th>
            <Th>
              案件名
              {isReverse['project_name'] ? (
                <IconButton
                  aria-label="search"
                  onClick={onClickSortReverse}
                  icon={<AiOutlineSortDescending />}
                />
              ) : (
                <IconButton
                  aria-label="search"
                  onClick={() => onClickSort('project_name')}
                  icon={<AiOutlineSortAscending />}
                />
              )}
            </Th>
            <Th>
              見積作成日
              {isReverse['registered_date'] ? (
                <IconButton
                  aria-label="search"
                  onClick={onClickSortReverse}
                  icon={<BsSortNumericDown />}
                />
              ) : (
                <IconButton
                  aria-label="search"
                  onClick={() => onClickSort('registered_date')}
                  icon={<BsSortNumericUp />}
                />
              )}
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {projects.map((project, index) => {
            return (
              <Tr key={index}>
                <TableBodyMassProjectList
                  project={project}
                  onClickOpenProjectDetail={onClickOpenProjectDetail}
                />
              </Tr>
            )
          })}
        </Tbody>
      </Table>
    </TableContainer>
  )
}
